import { useEffect, useState } from "react";
import { IPagedPosts } from "./models";
import { PostsV2Service } from "../../common/services/api/api";
import { PostList } from "./postList/postList";

export const PostsFeed = () => {
  const [loading, setLoading] = useState(true);
  const [showMyPosts, setShowMyPosts] = useState(false);

  const [pagedPosts, setPagedPosts] = useState<IPagedPosts>({
    items: [],
    totalCount: 0,
    page: 1,
    pageSize: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  });

  useEffect(() => {
    fetchPosts();
  }, [showMyPosts]);

  const toggleShowMyPosts = async (isChecked: boolean) => {
    setShowMyPosts(isChecked);
    //await fetchPosts();
  };

  const fetchPosts = async (page: number = 1, pageSize: number = 10) => {
    if (showMyPosts) {
      await fetchMyPosts(page, pageSize);
    } else {
      await fetchAllPosts(page, pageSize);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const fetchAllPosts = async (page: number = 1, pageSize: number = 10) => {
    try {
      setLoading(true);

      const postService = new PostsV2Service();
      var response = await postService.getAll(page, pageSize);
      setPagedPosts(response.data);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMyPosts = async (page: number = 1, pageSize: number = 10) => {
    try {
      setLoading(true);

      const postService = new PostsV2Service();
      var response = await postService.getMyPosts(page, pageSize);

      setPagedPosts(response.data);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (page: number) => {
    await fetchPosts(page);
  };

  return (
    <>
      <main className="container mx-auto px-4 py-8 mb-auto relative">
        <div className="absolute top-0 right-0 text-white p-2">
          <label className="inline-flex items-center me-5 cursor-pointer">
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              checked={showMyPosts}
              onChange={(e) => toggleShowMyPosts(e.target.checked)}
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-[#1ab9d8] dark:peer-focus:ring-[#2de1fc] dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#2de1fc]"></div>
            <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
              My Posts
            </span>
          </label>
        </div>
        <PostList
          pagedPosts={pagedPosts}
          onPageChange={handlePageChange}
          isLoading={loading}
        />
      </main>
    </>
  );
};
